import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Product } from 'src/app/models/interface/product/product';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

type Sections = 'info' | 'data' | 'locations';
@Component({
  selector: 'app-product-depth-level-cfs',
  templateUrl: './product-depth-level-cfs.component.html',
  styleUrls: ['./product-depth-level-cfs.component.scss']
})
export class ProductDepthLevelCfsComponent implements OnInit, OnDestroy {

  private _item: Product;

  @Input()
  get item(): Product {
    return this._item;
  }

  set item(value: Product) {
    this._item = value;
    this.ngOnInit();
  }

  @Input() params: any;

  selected: Sections = 'info'
  showActions: boolean

  private subscriptions = new Subscription();

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit() {

    this.showActions = this.item.domainName === 'FTTH';

    this.subscriptions.add(this.activatedRoute.queryParamMap
      .pipe(
        map(queryParamMap => queryParamMap.get('tab')),
      )
      .subscribe((section: Sections) => {
        this.selected = section
      }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  changeSection(section: Sections) {
    this.selected = section;
  }
}
